import { render } from "./BindingsSection.vue?vue&type=template&id=d190bdba&scoped=true"
import script from "./BindingsSection.vue?vue&type=script&lang=js"
export * from "./BindingsSection.vue?vue&type=script&lang=js"

import "./BindingsSection.vue?vue&type=style&index=0&id=d190bdba&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d190bdba"]])

export default __exports__